import { format, parseISO, isValid } from 'date-fns';

/**
 * Format a snapshot / computed-at timestamp for consultant UI (user local timezone).
 * @param {string|Date|null|undefined} value
 * @returns {string}
 */
export const formatSnapshotTime = (value) => {
  if (!value) return '—';
  const date = value instanceof Date ? value : parseISO(String(value));
  if (!isValid(date)) return '—';
  return format(date, 'do MMM yyyy HH:mm');
};
